import React, {useCallback} from "react";
import Box from "@amzn/meridian/box";
import Modal from "@amzn/meridian/modal";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import {TRACKING_ID_LIST} from "./constants/DriverPackageSummaryConstants";

/* Shows autocomplete station code chooser and
*  inflates result
* */
export const TrackingIdListDialog = ({isModalOpen, onModelOpenChange, trackingIdList}) => {
    const closeModal = useCallback(() => onModelOpenChange(false), []);
    return (
        <Modal
            title={TRACKING_ID_LIST}
            open={isModalOpen}
            onClose={closeModal}
            scrollContainer="viewport"
            closeLabel="Close"
            width={400}>
            <Box height={400}>
                <Table headerRows={0} spacing="small">
                    {trackingIdList.map((item, index) => (
                        <TableRow key={item}>
                            <TableCell key={index}>{item}</TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Box>
        </Modal>
    );
};



// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/TrackingIdListDialog.js